module.exports = __webpack_public_path__ + "static/media/d-img.1c1b2755.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/d-img.svg
// module id = 528
// module chunks = 0